<template>
  <div class="loading">
    <transition name="fade">
        <div v-if="show" class="loading_box">
            <div class="img_box">
                <img src="../../images/logo_m.jpg" alt="" srcset="">
            </div>
        </div>
    </transition>
  </div>
</template>
<script>
export default {
    props:{
       
    },
  data() {
    return {
        show:false
    };
  },
  mounted() {},
  methods: {
      hide1(){
          this.show =false
      },
      show1(){
          this.show = true
      }
  }
};
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.loading{
    .loading_box{
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba(0,0,0,0.8);
        z-index: 1004;
        @keyframes loading {
            0%{
                transform: rotate(0);
            }
            100%{
                transform: rotate(360deg);
            }
        }
        .img_box{
            width: 100px;
            height: 100px;
            // background: #ffffff;
            margin:30vh auto;
            animation: loading 2s linear infinite;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/loading/loading.vue